import { request } from '../../core/apiManager';

export const TIMESHEET_LIST_RECEIVED = 'TIMESHEET_LIST_RECEIVED';
export const AVAILABLE_STUDENTS_RECEIVED = 'AVAILABLE_STUDENTS_RECEIVED';
export const TUTOR_SUBJECTS_RECEIVED = 'TUTOR_SUBJECTS_RECEIVED';
export const API_ERROR_OCCURRED = 'API_ERROR_OCCURRED';
export const STUDENT_REMAINING_HOURS_RECEIVED =
  'STUDENT_REMAINING_HOURS_RECEIVED';

export const getTimesheetList = (params = {}) => dispatch => {
  return request('timesheets/list', params, dispatch).then(data => {
    dispatch({
      type: TIMESHEET_LIST_RECEIVED,
      data
    });
  });
};

export const getAvailableStudents = (params = {}) => dispatch => {
  return request('timesheets/assigned_students', params, dispatch).then(
    data => {
      dispatch({
        type: AVAILABLE_STUDENTS_RECEIVED,
        data
      });
    }
  );
};

export const getTutorSubjects = (params = {}) => dispatch => {
  return request('subjects/list', params, dispatch).then(data => {
    dispatch({
      type: TUTOR_SUBJECTS_RECEIVED,
      data
    });
  });
};

export const getRemainingHours = (params = {}) => dispatch => {
  return request('timesheets/remaining_hours', params, dispatch).then(data => {
    dispatch({
      type: STUDENT_REMAINING_HOURS_RECEIVED,
      data,
      studentId: params.studentId
    });
  });
};

export const submitTimesheet = (params = {}) => dispatch => {
  return request('timesheets/submit_timesheet', params, dispatch);
};
// export const apiCompleted = (requestType, data) => ({
//   type: API_COMPLETED,
//   requestType,
//   data
// });
